import { useState } from "react";
import { Button } from "./Button";
import { Modal, ModalTitle } from "./Modal";

interface ConfirmOptions {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: "danger" | "primary";
}

interface ConfirmState extends ConfirmOptions {
  message: string;
  resolve: (confirmed: boolean) => void;
}

export function useConfirm() {
  const [state, setState] = useState<ConfirmState | null>(null);

  function confirm(
    message: string,
    options?: ConfirmOptions,
  ): Promise<boolean> {
    return new Promise((resolve) => setState({ message, resolve, ...options }));
  }

  function respond(confirmed: boolean) {
    state?.resolve(confirmed);
    setState(null);
  }

  const dialog = state && (
    <Modal onClose={() => respond(false)} scrollable={false}>
      {state.title && (
        <ModalTitle className="mb-2 shrink-0">{state.title}</ModalTitle>
      )}

      <div className="min-h-0 flex-1 overflow-y-auto">
        <p className="text-sm text-foreground">{state.message}</p>
      </div>

      <div className="mt-4 flex shrink-0 justify-end gap-3">
        <Button onClick={() => respond(false)} variant="secondary">
          {state.cancelLabel ?? "Cancel"}
        </Button>

        <Button
          onClick={() => respond(true)}
          variant={state.confirmVariant ?? "danger"}
        >
          {state.confirmLabel ?? "Confirm"}
        </Button>
      </div>
    </Modal>
  );

  return { confirm, dialog };
}
